import { render, staticRenderFns } from "./NearbyPoints.vue?vue&type=template&id=0d3916d4"
import script from "./NearbyPoints.vue?vue&type=script&lang=js"
export * from "./NearbyPoints.vue?vue&type=script&lang=js"
import style0 from "./NearbyPoints.vue?vue&type=style&index=0&id=0d3916d4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports